import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { AccessManagerService } from "../../auth/accessManager/accessManager.service";
import { AppLinksCfgService } from "../appLinks/appLinksCfg.service";
import { OfficeSelectorService } from "../officeSelector/officeSelector.service";
import { AppLinksProfessionalsCfgService } from "../appLinks/appLinksProfessionalsCfg.service";
import { FeaturePermissionsService } from "src/app/auth/raas/featurePermissions.service";
import { AppSelectionDialogComponent } from "./appSelectionDialog.component";
import { AccessManagerResourceActionType } from "../../auth/accessManager/accessManager.models";
import { AppGroup } from "./appGroup";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";

@Component({
    selector: 'launcher-mobile',
    templateUrl: './launcherMobile.component.html',
    standalone: false
})
export class LauncherMobileComponent implements OnInit, OnDestroy {
    @ViewChild(AppSelectionDialogComponent, { static: true }) appSelector: AppSelectionDialogComponent;
    public readonly groupApps = Array.apply(null, Array(Object.keys(AppGroup).length / 2)).map(() => 0);
    private officeChangedSubscription: Subscription;

    constructor(private appLinksCfgService: AppLinksCfgService, private appLinksProfessionalsCfgService: AppLinksProfessionalsCfgService,
        private officeSelectorService: OfficeSelectorService,
        private apigeeService: ApigeeService, private accessManagerService: AccessManagerService,
        private featurePermissionsService: FeaturePermissionsService) {

    }

    public optionSelected(event: Event, title: string, appGroup: AppGroup) {
        if (event) event.stopPropagation();
        this.appSelector.openDialog(title, appGroup, true);
    }

    public ngOnInit(): void {
        this.prefetchAppPermissions();
        this.officeChangedSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.prefetchAppPermissions(); });
    }

    public ngOnDestroy(): void {
        if (this.officeChangedSubscription) this.officeChangedSubscription.unsubscribe();
    }

    private async prefetchAppPermissions(): Promise<void> {
        if (this.officeSelectorService.selectedOffice) {
            this.groupApps.fill(0);
            if (this.apigeeService.apiToken) {
                let appLinks = (await this.featurePermissionsService.professionalsEnabled() && !this.officeSelectorService.selectedOffice.isTEA) ? this.appLinksProfessionalsCfgService.getCfg().appLinks : this.appLinksCfgService.getCfg().appLinks;
                let promises = appLinks.map(x => {
                    return new Promise<void>((resolve, reject) => {
                        this.accessManagerService.getResourcePermissions(x.resourceId)
                            .then((p) => {
                                if (p.getResourceAction(AccessManagerResourceActionType.WindowAccess)) this.groupApps[x.group]++;
                                resolve();
                            })
                            .catch((error) => reject(error));
                    });
                });
                await Promise.all(promises);
            }
        }
    }
}
